import React, { useState } from 'react';

import cs from 'classnames';

import Button from 'components/shared/Button/Button';
import Textarea from 'components/shared/Textarea/Textarea';

const CommentInput = ({ className = '', loading, onPost = () => {} }) => {
  const [comment, setComment] = useState('');

  const handlePost = () => {
    if (comment.trim() === '' || loading) return;
    onPost(comment);
    setComment('');
  };

  return (
    <div className={cs('relative flex flex-col gap-2', className)}>
      <Textarea
        placeholder="Write a comment..."
        bodyClassName="h-[92px] w-full border rounded-lg border-solid border-neutral-200 placeholder:text-neutral-500"
        textareaClassName="h-full w-[calc(100%-40px)]"
        value={comment}
        onChange={(e) => setComment(e.target.value)}
      />
      <Button
        text="Add comment"
        className="!absolute !bottom-2 !right-2"
        size="small"
        onClick={handlePost}
        isDisabled={!!loading}
        isLoading={loading}
      />
    </div>
  );
};

export default CommentInput;
